// extracted by mini-css-extract-plugin
export default {"keywords":"keywords_keywords__qqejG","keywords__add":"keywords_keywords__add__rqivN","keywords__wrapper":"keywords_keywords__wrapper__zkEih","button":"keywords_button__jGbFi"};